export const actions = {
  GET_PLAYERS_REQUEST: "GET_PLAYERS_REQUEST",
  GET_PLAYERS_SUCCESS: "GET_PLAYERS_SUCCESS",

  CREATE_PLAYERS_REQUEST: "CREATE_PLAYERS_REQUEST",
  CREATE_PLAYERS_SUCCESS: "CREATE_PLAYERS_SUCCESS",
  BULK_UPLOAD_PROGRESS: "BULK_UPLOAD_PROGRESS",

  UPDATE_PLAYER_REQUEST: "UPDATE_PLAYER_REQUEST",
  UPDATE_PLAYER_SUCCESS: "UPDATE_PLAYER_SUCCESS",

  GET_ALL_PLAYERS_REQUEST: "GET_ALL_PLAYERS_REQUEST",
  GET_ALL_PLAYERS_SUCCESS: "GET_ALL_PLAYERS_SUCCESS",
  CLEAR_ALL_PLAYERS: "CLEAR_ALL_PLAYERS",

  GET_ARCHIVED_PLAYERS_REQUEST: "GET_ARCHIVED_PLAYERS_REQUEST",
  GET_ARCHIVED_PLAYERS_SUCCESS: "GET_ARCHIVED_PLAYERS_SUCCESS",

  GET_CLUB_REQUEST: "GET_CLUB_REQUEST",
  GET_CLUB_SUCCESS: "GET_CLUB_SUCCESS",

  GET_PLAYER_COURSES_REQUEST: "GET_PLAYER_COURSES_REQUEST",
  GET_PLAYER_COURSES_SUCCESS: "GET_PLAYER_COURSES_SUCCESS",

  GET_PLAYER_STATUS_REQUEST: "GET_PLAYER_STATUS_REQUEST",
  GET_PLAYER_STATUS_SUCCESS: "GET_PLAYER_STATUS_SUCCESS",

  GET_PLAYER_CATEGORY_REQUEST: "GET_PLAYER_CATEGORY_REQUEST",
  GET_PLAYER_CATEGORY_SUCCESS: "GET_PLAYER_CATEGORY_SUCCESS",

  REMOVE_PLAYER_REQUEST: "REMOVE_PLAYER_REQUEST",
  REMOVE_PLAYER_SUCCESS: "REMOVE_PLAYER_SUCCESS",

  UNREMOVE_PLAYER_REQUEST: "UNREMOVE_PLAYER_REQUEST",
  UNREMOVE_PLAYER_SUCCESS: "UNREMOVE_PLAYER_SUCCESS",

  DELETE_PLAYER_REQUEST: "DELETE_PLAYER_REQUEST",
  DELETE_PLAYER_SUCCESS: "DELETE_PLAYER_SUCCESS",

  ADD_TRANSFERABLE_REQUEST: "ADD_TRANSFERABLE_REQUEST",
  ADD_TRANSFERABLE_SUCCESS: "ADD_TRANSFERABLE_SUCCESS",

  UPDATE_TRANSFERABLE_REQUEST: "UPDATE_TRANSFERABLE_REQUEST",
  UPDATE_TRANSFERABLE_SUCCESS: "UPDATE_TRANSFERABLE_SUCCESS",

  DELETE_TRANSFERABLE_REQUEST: "DELETE_TRANSFERABLE_REQUEST",
  DELETE_TRANSFERABLE_SUCCESS: "DELETE_TRANSFERABLE_SUCCESS",

  GET_TRANSFERABLE_REQUEST: "GET_TRANSFERABLE_REQUEST",
  GET_TRANSFERABLE_SUCCESS: "GET_TRANSFERABLE_SUCCESS",

  GET_ALUMNI_PLAYERS_REQUEST: "GET_ALUMNI_PLAYERS_REQUEST",
  GET_ALUMNI_PLAYERS_SUCCESS: "GET_ALUMNI_PLAYERS_SUCCESS",

  MOVE_TO_ALUMNI_SUCCESS: "MOVE_TO_ALUMNI_SUCCESS",

  RESTORE_ALUMNI_REQUEST: "RESTORE_ALUMNI_REQUEST",
  RESTORE_ALUMNI_SUCCESS: "RESTORE_ALUMNI_SUCCESS",

  BULK_MOVE_TO_ALUMNI_REQUEST: "BULK_MOVE_TO_ALUMNI_REQUEST",
  BULK_ARCHIVE_REQUEST: "BULK_ARCHIVE_REQUEST",

  CREATE_INDIVIDUAL_USER_REQUEST: "CREATE_INDIVIDUAL_USER_REQUEST",
  CREATE_INDIVIDUAL_USER_SUCCESS: "CREATE_INDIVIDUAL_USER_SUCCESS",

  GET_INDIVIDUAL_USERS_REQUEST: "GET_INDIVIDUAL_USERS_REQUEST",
  GET_INDIVIDUAL_USERS_SUCCESS: "GET_INDIVIDUAL_USERS_SUCCESS",

  ARCHIVE_INDIVIDUAL_USER_REQUEST: "ARCHIVE_INDIVIDUAL_USER_REQUEST",

  CATCH_ERROR: "CATCH_ERROR",

  getPlayers: (data) => {
    return {
      type: actions.GET_PLAYERS_REQUEST,
      data,
    };
  },

  createPlayers: (data, userType, navigate) => {
    return {
      type: actions.CREATE_PLAYERS_REQUEST,
      data,
      userType,
      navigate,
    };
  },

  updatePlayer: (data, userType) => {
    return {
      type: actions.UPDATE_PLAYER_REQUEST,
      data,
      userType,
    };
  },

  getClub: () => {
    return {
      type: actions.GET_CLUB_REQUEST,
    };
  },

  clearAllPlayers: () => ({ type: actions.CLEAR_ALL_PLAYERS }),

  getAllPlayers: (data) => {
    return {
      type: actions.GET_ALL_PLAYERS_REQUEST,
      data,
    };
  },

  getArchivedPlayers: (data) => {
    return {
      type: actions.GET_ARCHIVED_PLAYERS_REQUEST,
      data,
    };
  },

  getPlayerStatus: () => {
    return {
      type: actions.GET_PLAYER_STATUS_REQUEST,
    };
  },

  getPlayerCategory: (clubId) => {
    return {
      type: actions.GET_PLAYER_CATEGORY_REQUEST,
      clubId,
    };
  },

  deletePlayer: (data, userType) => {
    return {
      type: actions.DELETE_PLAYER_REQUEST,
      data,
      userType,
    };
  },

  getCoursesOfUser: (data) => {
    return {
      type: actions.GET_PLAYER_COURSES_REQUEST,
      data,
    };
  },

  createTransferableSkill: (data) => {
    return {
      type: actions.ADD_TRANSFERABLE_REQUEST,
      data,
    };
  },

  updateTransferableSkill: (data) => {
    return {
      type: actions.UPDATE_TRANSFERABLE_REQUEST,
      data,
    };
  },

  deleteTransferableSkill: (data) => {
    return {
      type: actions.DELETE_TRANSFERABLE_REQUEST,
      data,
    };
  },

  getTransferableSkill: (data) => {
    return {
      type: actions.GET_TRANSFERABLE_REQUEST,
      data,
    };
  },

  getAlumniPlayers: (data) => {
    return {
      type: actions.GET_ALUMNI_PLAYERS_REQUEST,
      data,
    };
  },

  restoreAlumni: (id, assignClub, userType) => {
    return {
      type: actions.RESTORE_ALUMNI_REQUEST,
      id,
      assignClub,
      userType,
    };
  },

  bulkMoveToAlumni: (emails, userType) => {
    return {
      type: actions.BULK_MOVE_TO_ALUMNI_REQUEST,
      emails,
      userType,
    };
  },

  bulkArchive: (emails, userType) => {
    return {
      type: actions.BULK_ARCHIVE_REQUEST,
      emails,
      userType,
    };
  },

  createIndividualUser: (data) => {
    return {
      type: actions.CREATE_INDIVIDUAL_USER_REQUEST,
      data,
    };
  },

  getIndividualUsers: () => {
    return {
      type: actions.GET_INDIVIDUAL_USERS_REQUEST,
    };
  },

  // Archiving hides the account from Control Centre. Kept separate from
  // bulkArchive, which updates the club players slice rather than this list.
  archiveIndividualUser: (id) => {
    return {
      type: actions.ARCHIVE_INDIVIDUAL_USER_REQUEST,
      id,
    };
  },
};
